import { apiFetch } from './client';

export type ConferenceMode = 'open' | 'moderated' | 'private';

export interface ConferenceRoomRow {
  id: string;
  reseller_id: string;
  customer_id: string;
  ref_number: string;
  name: string;
  mode: ConferenceMode;
  max_participants: number;
  has_admin_pin: boolean;
  has_participant_pin: boolean;
  active: boolean;
  /** Optional FK to recording_folders. NULL = use the auto-created
   *  "Conference recordings" folder under the customer. */
  recording_target_folder_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateRoomBody {
  name: string;
  admin_pin: string;
  participant_pin?: string | null;
  mode?: ConferenceMode;
  max_participants?: number;
  customer_id?: string;
}

export type PatchRoomBody = Partial<{
  name: string;
  admin_pin: string;
  participant_pin: string | null;
  mode: ConferenceMode;
  max_participants: number;
  active: boolean;
  /** Pass `null` to explicitly clear the recording folder binding;
   *  omit (undefined) to leave it untouched. */
  recording_target_folder_id: string | null;
}>;

export const conferenceRooms = {
  list: (p: { search?: string; limit?: number; customer_id?: string } = {}) => {
    const q = new URLSearchParams();
    if (p.search) q.set('search', p.search);
    if (p.limit) q.set('limit', String(p.limit));
    if (p.customer_id) q.set('customer_id', p.customer_id);
    return apiFetch<{ rows: ConferenceRoomRow[] }>(`/api/conference-rooms?${q}`);
  },
  get: (id: string) => apiFetch<ConferenceRoomRow>(`/api/conference-rooms/${id}`),
  create: (body: CreateRoomBody) =>
    apiFetch<ConferenceRoomRow>('/api/conference-rooms', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: string, patch: PatchRoomBody) =>
    apiFetch<ConferenceRoomRow>(`/api/conference-rooms/${id}`, { method: 'PATCH', body: JSON.stringify(patch) }),
  remove: (id: string) => apiFetch<void>(`/api/conference-rooms/${id}`, { method: 'DELETE' }),
};
